export default __webpack_public_path__ + "static/media/FluxCoreWeldingImg.70c4017e.jpg";